import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import login from "./modules/LoginModule";
import featureToggling from "./modules/FeatureTogglingModule";

Vue.use(Vuex);

const store = new Vuex.Store({
	state,
	actions,
	mutations,
	getters,
	modules: {
		login,
		features: featureToggling,
	},
});

export default store;
